import { RenderHtml, OverlayDialog } from '@flos/react-components';
import { Button } from '@material-ui/core';
import { useStateValue } from '../../../hooks/UseStateValue';
import { CUSTOMER_STATUS } from '../../../interfaces/IEmailPayload';

export interface LoginCheckProps {
  overlayOpen: boolean;
  customerStatus: CUSTOMER_STATUS;
  onDialogClose: () => void;
  full?: boolean;
}

export const LoginCheck = ({
  overlayOpen,
  customerStatus,
  onDialogClose,
  full = true
}: LoginCheckProps): JSX.Element => {
  const [{ labels, contentBlocks }] = useStateValue();

  return (
    <OverlayDialog title="" open={overlayOpen} closeButton={true} onClose={onDialogClose}>
      {customerStatus === CUSTOMER_STATUS.AGE_BELOW_18 && (
        <>
          <RenderHtml html={contentBlocks.customerTooYoung} />
          <Button href={labels.error.contact.link} fullWidth variant="contained">
            {labels.button.contact}
          </Button>
        </>
      )}
      {customerStatus === CUSTOMER_STATUS.AGE_ABOVE_68 && (
        <>
          <RenderHtml html={full ? contentBlocks.customerTooOld : contentBlocks.overlayCustomerTooOld} />
          <Button href={labels.error.contact.link} fullWidth variant="contained">
            {labels.button.contact}
          </Button>
        </>
      )}
      {customerStatus === CUSTOMER_STATUS.BORNHOLM && (
        <>
          <RenderHtml html={contentBlocks.bornholm} />
          <Button href={labels.error?.bornbrand?.link} fullWidth variant="contained">
            {labels.button.bornholm}
          </Button>
        </>
      )}
      {customerStatus === CUSTOMER_STATUS.INSURANCE_EXIST && (
        <>
          <RenderHtml html={contentBlocks.insuranceExists.replace('{{forsikring}}', 'ulykkesforsikring')} />
          <Button href={labels.error.mittopdanmark?.link} fullWidth variant="contained">
            {labels.button.mittopdanmark}
          </Button>
        </>
      )}
      {customerStatus === CUSTOMER_STATUS.MARKED && <RenderHtml html={contentBlocks.customerRejection} />}
    </OverlayDialog>
  );
};
